(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-rhythm-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fall-rhythm').forEach(function (banner) {
  const video = banner.querySelector('video');
  const button = banner.querySelector('.fall-rhythm__pause');
  function sync() {
    const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    button.textContent = label;
    button.setAttribute('aria-label', label);
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
  video.addEventListener('play', sync);
  video.addEventListener('pause', sync);
  button.addEventListener('click', function () {
    if (video.paused) video.play().catch(sync);
    else video.pause();
    sync();
  });
  sync();
});

  } catch(e) { console.error(e); }
})();
})();
